<template>
  <main id='Home' v-if='kirby.page.template'>
    <section id='Images'>
      <figure v-for='(image) in kirby.page.content.images' :key='image.id'>
        <transition name='slow'>
          <srcset :file='kirby.pages.home.files[image.image[0].value]'
                  sizes='60vw' />
        </transition>
      </figure>
    </section>
    <footer id='DateAndTitle'>
      <time>{{formattedDate(kirby.site.startdate, 'd.m')}} - {{formattedDate(kirby.site.enddate, 'd.m.yyyy')}}</time>
      <big>{{kirby.site.title}}</big>
    </footer>
  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>


<style>

  main#Home {
    position: static;
    box-sizing: border-box;
    height: 100%;
    padding-left: calc(7vw + 5rem);
    padding-top: 12rem;
  }

  section#Images {
    padding-right: 2rem;
    padding-bottom: 9rem;
  }

  section#Images figure {
    width: 70vw;
    margin-bottom: 3rem;
  }

  section#Images figure:nth-child(odd) {
    margin-left: 0;
  }

  section#Images figure:nth-child(even) {
    margin-left: auto;
  }

  section#Images figure:nth-child(odd) img {
    object-position: left;
  }

  section#Images figure:nth-child(even) img {
    object-position: right;
  }

  footer#DateAndTitle {
    position: fixed;
    bottom: 3rem;
    right: 2rem;
  }

  footer#DateAndTitle time {
    font-size: 1.25vw;
    vertical-align: top;
  }

  footer#DateAndTitle big {
    text-transform: uppercase;
    font-size: 3vw;
    display: block;
    vertical-align: top;
    display: inline-block;
    width: 12em;
    line-height: 0.8em;
    word-spacing: -0.05em;
    text-align: center;
    letter-spacing: -0.065em;
  }

</style>
